import { render, staticRenderFns } from "./SurveyLayout.vue?vue&type=template&id=6cf75e9a"
import script from "./SurveyLayout.vue?vue&type=script&lang=ts"
export * from "./SurveyLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports